import { Api, Parameter } from '../api';
import { format_date, format_percentage } from '../shared/formatters';
import { Note } from '../shared/note';

export const COLS_FULL: {
  key: keyof Parameter;
  label: React.ReactNode;
  truncate?: boolean;
  searchable: boolean;
  sortable: boolean;
  cell?: (row: Parameter) => React.ReactNode;
}[] = [
  {
    key: 'date',
    label: 'Timestamp',
    searchable: true,
    sortable: true,
    cell: (row) => format_date(row.date),
  },
  {
    key: 'label',
    label: 'Parametro (udm)',
    searchable: true,
    sortable: true,
    cell: (row) => `${row.label} (${row.unit})`,
  },
  {
    key: 'value',
    label: 'Valore',
    searchable: true,
    sortable: true,
    cell: (row) => {
      if (row.unit === '%') return format_percentage(row.value);
      return row.value;
    },
  },
  {
    key: 'workstation',
    label: 'Centro',
    searchable: true,
    sortable: true,
  },
  {
    key: 'notes',
    label: 'Note',
    searchable: true,
    sortable: true,
    cell: (row) => (
      <Note
        id={row.id}
        initialValue={row.notes}
        onSave={(id, v) => Api.set_note_on_parameter(id, v)}
      />
    ),
  },
];
